









import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo: {
    title: '404 Page not found',
  },
})
export default class NotFound extends Vue {}
